import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';

export class LocationsSelectionModel {
  locations: ClientLocationDataModel[] = [];
  operatories: OperatoryDataModel[] = [];
}
